export default "__VITE_ASSET__Dctaw5kS__"